// extracted by mini-css-extract-plugin
module.exports = {"alfredFooterRoot":"t7CEHEFK","hidden":"fIE_kI2V","fixed":"_7jIqToA0","sticky":"xiPJrNlC","leftControls":"dpRgan7T","leftControlsHidden":"Igo0i6cZ","inputRegion":"L5kqDJiS"};